<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2 mx-1">
            {{ isNew ? "Створення назви департаменту" : "Назва департаменту" }}
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="Department"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-form>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" class="pb-0">
                <CustomTextField
                  v-model="title"
                  label="Найменування*"
                  class="ma-1"
                  :error-messages="$v.title.$error ? errors.TITLE : []"
                  :hide-details="false"
                  @input="$v.title.$touch()"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions v-if="!modal">
            <PrimaryBtn
              :has-warnings="$v.$invalid"
              :loading="loading"
              @click="save"
            />
            <v-btn @click="$router.go(-1)">
              Відмінити
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import * as departmentsApi from "../../../backend/departmentsApi.js";
import PrimaryBtn from "@/components/PrimaryBtn.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    PrimaryBtn,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],
  data: () => ({
    title: "",
    loading: false,
    isChanged: false,
  }),

  validations: {
    title: {
      required,
    },
  },

  computed: {
    isNew() {
      return +this.id ? false : true;
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (+this.id) {
      departmentsApi.getDepartment(this.id).then((department) => {
        this.title = department.title;
      });
    }
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      try {
        if (!this.isNew) {
          await departmentsApi.updateDepartment(this.id, this.title);
        } else {
          await departmentsApi.createDepartment(this.title);
        }
        this.$notifySuccess();
        this.$router.go(-1);
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
        this.isChanged = false;
      }
    },
  },
};
</script>
